import UserService from "src/services/UserService";


const Authenticated = ({ children }) => (UserService.isLoggedIn()) ? children : null;
//const Authenticated = ({ children }) => ("a"==="a") ? children : null;
export default Authenticated
